import {useGetUserPermission} from "../hook/permissions";

// Regra de acesso a uma rota do painel, sem React. Existe separada do componente
// abaixo porque a barra lateral precisa da lista já filtrada antes de renderizar
// (a busca de menus mostra "nenhum encontrado" e abre o primeiro resultado).
export function temPermissao({permissions = [], module = []}, {permissoes = [], modulos = []}) {
    const hasPermissions = permissions.some(permission => permissoes.includes(permission));

    const hasModules = !module || module.length === 0 || modulos.some(modulo => {
        return module.includes(modulo)
    })

    return hasPermissions && hasModules;
}

const PermissionGate = ({children, permissions, module = []}) => {
    const userPermissions = useGetUserPermission() || [];
    const {modulos = []} = JSON.parse(localStorage.getItem('usuario')) || {};

    if (temPermissao({permissions, module}, {permissoes: userPermissions, modulos})) {
        return children;
    }

    return null;
}

export default PermissionGate; 
